import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'avn/services/api.service';
import { Constants } from 'avn/services/constants';
import { StoreService } from 'avn/services/store.service';

@Component({
  selector: 'app-category-group',
  templateUrl: './category-group.component.html',
  styleUrls: ['./category-group.component.scss']
})
export class CategoryGroupComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private store: StoreService,
    private api: ApiService
  ) {}

  categoryGroups: any = [];

  groupName = '';

  ngOnInit(): void {
    const value = this.route.snapshot.routeConfig?.path || '';
    this.groupName = value.charAt(0).toUpperCase() + value.slice(1);
    this.categoryGroups = Constants.CATEGROY_GROUPS[this.groupName];
  }
}
